import { submitPersonalLoanInquiry } from 'app/actions/form/actions';
import { FieldNames } from 'app/models/fields/names';
import { personalLoanInquiryQuestionById, personalLoanInquiryQuestionsByName } from 'app/models/questions/personal-loan-inquiry';
import {
  PERSONAL_LOAN_INQUIRY_BORROWER_DATA,
  PERSONAL_LOAN_INQUIRY_FINAL_QUESTION,
  PERSONAL_LOAN_INQUIRY_FINAL_SECTION,
  PERSONAL_LOAN_INQUIRY_GET_LOAN_AMOUNT_SECTION,
} from 'app/models/sections/constants';
import { Section } from 'app/models/types';

export const getPersonalLoanInquiryById = (id: number): Section => {
  return PERSONAL_LOAN_INQUIRY_INQUIRY_SECTIONS.find((section) => section.id === id) as Section;
};

const PERSONAL_LOAN_INQUIRY_INQUIRY_SECTIONS: Section[] = [
  {
    id              : PERSONAL_LOAN_INQUIRY_GET_LOAN_AMOUNT_SECTION,
    hideProgressBar : true,
    hideBackButton  : true,
    title           : 'What is your desired loan amount?',
    questions       : personalLoanInquiryQuestionsByName([FieldNames.loanAmount]),
  },
  {
    id        : PERSONAL_LOAN_INQUIRY_BORROWER_DATA,
    title     : 'Enter your personal information',
    questions : personalLoanInquiryQuestionsByName([
      FieldNames.firstName,
      FieldNames.middleName,
      FieldNames.lastName,
      FieldNames.suffixName,
      FieldNames.phone,
      FieldNames.email,
      FieldNames.dateOfBirth,
    ]),
    submitAction: submitPersonalLoanInquiry,
    submitText: 'Submit',
  },
  {
    id                : PERSONAL_LOAN_INQUIRY_FINAL_SECTION,
    questions         : [personalLoanInquiryQuestionById(PERSONAL_LOAN_INQUIRY_FINAL_QUESTION)],
    hideBackButton    : true,
    hideForwardButton : true,
    hideProgressBar   : true,
  },
];
